import { render, staticRenderFns } from "./subViewScoreItems.vue?vue&type=template&id=13c2d680&scoped=true&"
import script from "./subViewScoreItems.vue?vue&type=script&lang=js&"
export * from "./subViewScoreItems.vue?vue&type=script&lang=js&"
import style0 from "./subViewScoreItems.vue?vue&type=style&index=0&id=13c2d680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2d680",
  null
  
)

export default component.exports